
export default class ResetPrimaryPasswordRequestModel {
    public passwordResetToken: string = '';
    public backupPassword: string = '';
    public primaryPassword: string = '';
}
